/**=========================================================
 * Module: dev.js
 * Dev Controller
 =========================================================*/

 App.controller('DevController',
 ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', '$filter', '$http', 'DataService', 'ngDialog',
   function ($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, $filter, $http, D, ngDialog) {
     "use strict";

     

     $scope.initialized = false;
     $scope.watchActivated = false;
     $scope.init = function(){

       if ($rootScope.user && $rootScope.user.id) {

        $scope.loadApiKeys = function () {
          D.query('session','apikey=true').then(function (response) {
              $scope.apiKeys = response;
          })
        }
        $scope.loadApiKeys()


           
         $scope.apikeyForm = {
            title: 'Create API Key',
            status: '',
            type: 'session',
            model: {},
            fields: [
                {
                    available: true,
                    type: 'text',
                    name: 'name',
                    label: 'Name',
                    required: true
                },
                {
                    available: $rootScope.user.admin,
                    type: 'text',
                    name: 'account',
                    label: 'Account ID',
                    required: true
                },
                {
                    available: true,
                    type: 'checkboxes',
                    name: 'scopes',
                    label: 'Scopes',
                    data: [
                        { name: 'read:project' },
                        { name: 'read:offer' },
                        { name: 'read:analysis' }
                    ],
                    valueField: 'name',
                    labelField: 'name',
                    required: true
                },
                {
                    available: true,
                    type: 'submit',
                    label: 'Create new API Key',
                }
            ],
            submit: function () {
                $scope.apikeyForm.status = 'submitting'
                $scope.apikeyForm.model.action = 'CreateApiKey'
                D.save('session', $scope.apikeyForm.model).then(function (response) {
                    $scope.apikeyForm.status = ''
                    $scope.apikeyForm.model = {}
                    $scope.apiKey = response
                    ngDialog.open({
                        template: '/app/views/partials/apikey.html',
                        className: 'ngdialog-theme-default',
                        scope: $scope
                    })
                    $scope.loadApiKeys()
                })
            }

         }

         $scope.revokeApiKey = function (apikey) {
            ngDialog.openConfirm({
              template: '/app/views/entities/confirm.html',
              className: 'ngdialog-theme-default',
              scope: $scope
            }).then(function (value) {
              D.save('session', { apiKeyId: apikey, action: 'RevokeApiKey' }).then(function (response) {
                $scope.loadApiKeys()
              })
            })
          }

       } else {
         if (!$scope.watchActivated) {
           $scope.watchActivated = true;
         
           $rootScope.$watch('user.id', function () {
             if (!$scope.initialized) {
               $scope.init();
             }
           });

         }
       }
       }
   $scope.init()

     






   }
 ]);